'use client';

import type { ReactNode } from 'react';
import { ButtonGroup } from '@zillow/constellation-10';
import { listingActionGlass } from './listingActionCluster.styles';

type ListingActionClusterProps = {
  children: ReactNode;
  label: string;
};

export const ListingActionCluster = ({ children, label }: ListingActionClusterProps) => (
  <ButtonGroup
    role="group"
    aria-label={label}
    tone="neutral"
    emphasis="bare"
    size="sm"
    css={listingActionGlass.raw({ layout: 'cluster' })}
  >
    {children}
  </ButtonGroup>
);
